"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _selectablelist_styles = _interopRequireDefault(require("./selectablelist_styles"));

var _selectablelist_definition = _interopRequireDefault(require("./selectablelist_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
//materials
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : LIST : SELECTABLE ~~~~~~~~~~ ========== */


var SelectableList = (0, _reactJss.default)(_selectablelist_styles.default)(function (props) {
  var singleItem = function singleItem(item) {
    return typeof item === "string";
  };

  var hasItems = function hasItems() {
    return Array.isArray(props.items) && props.items.length > 0;
  };

  var getListType = function getListType() {
    switch (props.type) {
      case 'checkbox':
        return renderList(_index.CheckboxField);

      case 'fancyradio':
        return renderList(_index.Radio);

      case 'radio':
      default:
        return renderList(_index.RadioField);
    }
  };

  var renderList = function renderList(type) {
    return props.items.map(function (item, index) {
      var value = item.value,
          text = item.text;

      var currentElement = _react.default.createElement(type, {
        key: index,
        name: value,
        isList: true,
        disabled: props.disabled ? singleItem(props.disabled) ? props.disabled === value : props.disabled.includes(value) : false,
        checked: props.selected ? singleItem(props.selected) ? props.selected === value : props.selected.includes(value) : false,
        handleChange: function handleChange() {
          return props.handleChange(value);
        }
      });

      return type === _index.Radio ? _react.default.cloneElement(currentElement, {
        title: text
      }) : _react.default.createElement("label", {
        key: index,
        className: "list-item"
      }, currentElement, _react.default.createElement("div", {
        className: "option-text"
      }, text));
    });
  };

  return _react.default.createElement("div", {
    className: "list selectablelist ".concat(props.classes.selectablelist, " ").concat(props.klass ? props.klass : '', " name-").concat(props.name)
  }, hasItems() ? _react.default.createElement(_index.GridSet, {
    direction: 'vertical'
  }, getListType()) : null);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SelectableList, _selectablelist_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = SelectableList;
exports.default = _default;